import AiChat from "./ai/AiChat";
import PageFrame from "./PageFrame";

/** Career › AI career advisor: chat that knows the student's courses, CV review and job matches. */
export default function CareerAdvisorPage() {
  return (
    <PageFrame kicker="Career" title="AI Career Advisor" intro="Plan your next career step, improve your CV, get ready for interviews and make the most of your job matches.">
      <AiChat
        kind="career"
        name="AI Career Advisor"
        intro="I can see your courses, your CV review and your job matches. Ask me anything about getting into tech."
        suggestions={["Build me a 3-month career roadmap", "How can I improve my CV?", "Which of my job matches should I apply to first?", "Give me a mock interview"]}
      />
    </PageFrame>
  );
}
